import * as _ from 'underscore';

import { DestinationProject } from '@tableau/nested-project-explorer';
import { IDestinationProject } from '../ServerApi/types/IDestinationProject';

export namespace DestinationProjectMapper {

  export function map(destinationProjects: IDestinationProject[]): DestinationProject[] {
    return _.map(destinationProjects, p => ({
      id: String(p.id),  // the api returns numbers but we want strings
      name: p.name || '',
      parentProjectId: p.parentProjectId,
      childProjectCount: p.childProjectCount,
      topLevelProject: p.topLevelProject,
      controlledPermissionsEnabled: p.controlledPermissionsEnabled,
      status: p.status
    }));
  }
}
